const filterCartGoodsMixin = {
    methods: {
        getCartByLabel (cart, ids) {
            const distributeCart = []
            cart.forEach(g => {
                const shoppingCarts = g.shoppingCarts
                    .filter(i => ids.includes(i.shoppingCartId))
                if (shoppingCarts.length) {
                    distributeCart.push({
                        ...g,
                        expand: false,
                        shoppingCarts
                    })
                }
            })
            return distributeCart
        }
    }
}

export default filterCartGoodsMixin
